import logo from "assets/images/brands/Neolin_lg.png";
import logoSm from "assets/images/brands/Neolin_sm.png";
// import exinitic from "assets/images/brands/logo.png";
// import lLogo from "assets/images/brands/logo.png";

export const clientName = "Neolin";
export const developedBy = "Neolin";
export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_CP_DOMAIN;
export const companyName =  "Neolin";
export const companyWebsite = "www.neolinfx.com";
export const executionPolicy = "#";
export const conflictPolicy = "#";
export const disclosurePolicy = "#";
export const clientAgreementLink = "#";
export const privacyPolicyLink = "https://neolinfx.com/privacy-policy";
export const riskWarningLink = "https://neolinfx.com/risk-warning";
export const riskDisclosure = "https://neolinfx.com/risk-discloser";
export const cookiesPolicyLink = "https://neolinfx.com/cookies-policy";
export const copyTradingAndMalfunctionPolicy = "https://neolinfx.com/copy-trading-malfunction";
export const sidebarLogo = logo;
export const smLogo = logoSm;
export const mainLogo = logo;
export const lightLogo = logo;
